module.exports = __webpack_public_path__ + "media/images/home-073bed6246a5e9ac17abc1dcda68e859.svg";